import {Step} from '../Step/Step'
import {MaximizedAvailability} from './MaximizedAvailability'
import {MinimizedAvailanility} from './MinimizedAvailability'

export const Availability = () => {
  return (
    <Step
      title="Start time"
      caption="Choose your start time"
      thisStepCode="availability"
      minimizedComponent={MinimizedAvailanility}
      maximizedComponent={MaximizedAvailability}
    />
  )
}
